const TEXT = {
  CTA: {id: 'myLK.orderPlaced.comment.main_cta'},
  COMMENT_TITLE: {id: 'myLK.orderPlaced.comment.title'},

  INPUT_COMMENT: {id: 'myLK.orderPlaced.comment.placeholder'},

  NOTIFICATION_SUCCESS: {id: 'myLK.orderPlaced.comment.toast_success'},

  TITLE: {id: 'myLK.orderPlaced.title'},
  TITLE_DATE: {id: 'myLK.orderPlaced.title_date'},
  TOOLTIP_TITLE: {id: 'myLK.order.comment_tooltip_title'},
  TOOLTIP_TEXT: {id: 'myLK.orderPlaced.comment.tooltip_example'},
  TOOLTIP_ACTION: {id: 'myLK.orderPlaced.comment.button_view'},
  TITLE_SHOP_MODEL_A: {id: 'shop.banner.title_A'},
  TITLE_SHOP_MODEL_B: {id: 'shop.banner.title_B'},
  BODY_SHOP_MODEL_A: {id: 'shop.banner.body_A'},
  BODY_SHOP_MODEL_B: {id: 'shop.banner.body_B'},
  CONTENT_SHOP_MODEL_A: {id: 'shop.banner.content_A'},
  CONTENT_SHOP_MODEL_B: {id: 'shop.banner.content_B'},
  CTA_SHOP_MODEL_A: {id: 'shop.banner.CTA_A'},
  CTA_SHOP_MODEL_B: {id: 'shop.banner.CTA_B'},
  TITLE_SALES: {id: 'shop.banner.sales_title'},
  BODY_SALES: {id: 'shop.banner.sales_body'},
  CONTENT_SALES: {id: 'shop.banner.sales_content'},
  CTA_SALES: {id: 'shop.banner.sales_CTA'},
};

const SOURCE = {
  RAF_MODAL: 'rafModal',
};

const IDS = {
  MY_LK_COMMENT: 'MyLKComment',
};

const MODAL_TIMEOUT = 4000;
const MODAL_SURVEY_TIMEOUT = 3000;

const DATE_FORMAT = {month: 'long', day: '2-digit', weekday: 'short'};

export {TEXT, SOURCE, IDS, MODAL_TIMEOUT, MODAL_SURVEY_TIMEOUT, DATE_FORMAT};
